import { IonContent, IonModal } from '@ionic/react';
import { type ComponentProps, type PropsWithChildren, type Ref } from 'react';

import styles from './DeleteClientModal.module.css';

import { Button } from '../Button';
import { ModalFooter } from '../ModalFooter/ModalFooter';
import { ModalHeader } from '../ModalHeader/ModalHeader';

interface ModalProps extends ComponentProps<typeof IonModal> {
  ref?: Ref<HTMLIonModalElement>;
  handleClose: VoidFunction;
  onConfirm: VoidFunction;
  clientName: string;
}

export const DeleteClientModal = ({
  onConfirm,
  handleClose,
  ref,
  clientName,
  ...props
}: PropsWithChildren<ModalProps>) => {
  return (
    <IonModal className={styles.modal} {...props} onDidDismiss={handleClose} ref={ref}>
      <ModalHeader>Delete client?</ModalHeader>
      <IonContent className={styles.content}>
        <div className={styles.inner}>
          <p className={styles.text}>
            {`Are you sure you want to delete ${clientName}?`} <br />
            Deleting this client will also <strong>delete all sessions and their recordings.</strong>
            <br />
            This action can’t be undone.
          </p>
        </div>
      </IonContent>
      <ModalFooter>
        <Button className={styles.button} onClick={handleClose} size='small' variant='secondary'>
          Cancel
        </Button>
        <Button className={styles.button} onClick={onConfirm} size='small' variant='danger'>
          Delete client
        </Button>
      </ModalFooter>
    </IonModal>
  );
};
